/**
 * Constants cho phần giao dự toán
 * @author dvhung2 17.04.2025
 */

export const BudgetType = {
  STATE: 1, // Chi ngân sách nhà nước  
  FEES: 2 // Phí - lệ phí, HĐSN dịch vụ
};

export const ExpenseType = {
  BALANCE_TARGET: 1, // Cân đối - Bổ sung mục tiêu
  REGULAR_TARGET: 2 // Chi thường xuyên - Chi CTMT
};

export const GridType = {
  BALANCE: 1, // Chi cân đối/Chi thường xuyên
  TARGET: 2 // Chi bổ sung mục tiêu/Chi CTMT  
};

export const UnitMoney = {
  MILLION: 2 // Triệu đồng
};

export const LockColumns = {
  ORDER: 'TemplateItemOrder',
  NAME: 'TemplateItemName', 
  TOTAL: 'total_amount'
};

// Export default object tổng hợp
export default {
  BudgetType,
  ExpenseType,
  GridType,
  UnitMoney,
  LockColumns
};
